import React from 'react';
import { FilterClearProps } from './props';
import { ClearOutlined } from '@ant-design/icons';
import { Container } from './styles';

const ClearFilterBtn: React.FC<FilterClearProps> = ({ children, onClick }) => {
  return (
    <Container
      icon={<ClearOutlined />}
      data-cy="btnLimparFiltros"
      type="ghost"
      onClick={onClick}
      size="middle"
      block
      htmlType="reset"
    >
      {children}
    </Container>
  );
};

export default ClearFilterBtn;
